import React from 'react';
import 'swiper/swiper-bundle.css';
import dynamic from 'next/dynamic';
import ChatWidget from '@/_application/themes/kidsplaza-spring/layouts/components/chat-widget';
import {DynamicPageServerSideProps} from '@/_application/core/types';
import {INIT_STORES_NUMBER} from '@/_application/themes/kidsplaza-spring/layouts/components/header/kidsplaza-spring.desktop.top-navigation-bar';
import {FlashMessageStack} from '@/nova/shared/components/flash-message-stack';

const HomeFloatBanner = dynamic(() => import('@/_application/pages/home/components/home-float-banner'), {ssr: false});

const TopNavHeader = dynamic(
    () =>
        import(
            '@/_application/themes/kidsplaza-spring/layouts/components/header/kidsplaza-spring.desktop.top-navigation-bar'
        ),
    {
        ssr: true,
    },
);
const Header = dynamic(
    () => import('@/_application/themes/kidsplaza-spring/layouts/components/header/kidsplaza-spring.desktop.header'),
    {
        ssr: true,
    },
);
const Footer = dynamic(
    () => import('@/_application/themes/kidsplaza-spring/layouts/components/footer/kidsplaza-spring.desktop.footer'),
    {
        ssr: true,
    },
);
const SubNavigationBar = dynamic(
    () =>
        import(
            '@/_application/themes/kidsplaza-spring/layouts/components/header/kidsplaza-spring.desktop.sub-navigation-bar'
        ),
    {
        ssr: true,
    },
);

function DesktopLayout({children, variables}: Readonly<React.PropsWithChildren<Partial<DynamicPageServerSideProps>>>) {
    const {storesNumber, categories, isHomepage} = variables ?? {storesNumber: INIT_STORES_NUMBER};

    return (
        <>
            <TopNavHeader storesNumber={storesNumber ?? INIT_STORES_NUMBER} />
            <Header />
            <nav aria-label="Main navigation" className="sticky left-0 top-[91px] z-20">
                <SubNavigationBar categories={categories} />
                <div className="sticky top-[130px] z-30">
                    <FlashMessageStack />
                </div>
                {isHomepage && <HomeFloatBanner />}
            </nav>
            <main id="main-content">{children}</main>
            <ChatWidget iconSize={60} />
            <footer>
                <Footer />
            </footer>
        </>
    );
}

export default DesktopLayout;
